import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

import classes from './styles/api-keys-table.module.scss';

interface FilterIconProps {
  active: boolean;
}

/**
 * `filter` glyph from the design (three tapering lines). Inherits color via
 * `currentColor` and turns blue while a filter is applied.
 */
export const FilterIcon: FunctionComponent<FilterIconProps> = ({ active }) => (
  <svg
    aria-hidden="true"
    className={classnames(classes.sortIcon, { [classes.sortIconActive]: active })}
    fill="none"
    focusable="false"
    height="8.5"
    viewBox="0 0 11.6667 7.66667"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.14103 3.83333H9.52564M0.5 0.5H11.1667M4.60256 7.16667H7.0641"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
